import React from 'react'
import hoc from '@hoc'
import PropTypes from 'prop-types'
import { API, AUTH } from '@const'
import * as utils from '@utils'
import { Tree } from 'antd'
import 'antd/dist/antd.css'
import {
    FormControlLabel,
    FormHelperText,
    Grid,
    Divider,
    Button,
    TextField,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Stepper,
    Step,
    StepLabel,
    Radio,
    RadioGroup,
    Checkbox,
} from '@material-ui/core'

const ROLE_ID_UNSET = -1

const initialState = {
    authorizationsTreeData: [],
    authorizationsCheckedKeys: [],
    authorizationsExpandedKeys: [],
    pfSubPfTreeData: [],
    pfSubPfCheckedKeys: [],
    pfSubPfExpandedKeys: [],
    rootRoleList: [],
    rootRoleID: ROLE_ID_UNSET,
    name: '',
    dialogOpen: false,
    stepper: {
        steps: ['roleType', 'info'],
        activeStep: 0,
    },
    roleType: AUTH.ROLE_TYPE.ROOT_ROLE,
    canAccessAllPf: false,
    valid: false,
    adminRole: {}
}

class AddRoleDialog extends React.Component {
    constructor(props) {
        super(props)
        this.t = (key) => {
            return utils.t(key, 'AddRoleDialog')
        }
        this.state = initialState
    }

    componentDidMount() {
        this.props.onRef(this)
    }

    componentWillUnmount() {
        this.props.onRef(undefined)
    }

    reset(roleList) {
        const adminRole = roleList.find((elem) => elem['id'] === 2)
        const rootRoleList = [
            ...roleList.filter((elem) => (elem['id'] === elem['root_role_id'] && elem['root_role_id'] !== 2)),
        ]

        const rootSortRoleList = utils.convertSort({ source: rootRoleList })
        
        this.setState(
            {
                ...initialState,
                rootRoleList: rootSortRoleList,
                adminRole
            },
            () => {
                if (!this.props.auth.isAdmin) {
                    this.setState(
                        {
                            rootRoleID: this.props.auth.userInfo['root_role_id'],
                            roleType: AUTH.ROLE_TYPE.NORMAL_ROLE,
                        },
                        () => {
                            this.stepperNext()
                        }
                    )
                }
                if (this.props.auth.isSuperUser || this.props.auth.userInfo.authorization_list.includes('role.administrator')) {
                    this.setState(
                        {
                            roleType: AUTH.ROLE_TYPE.ADMIN_ROLE
                        }
                    )
                }
            }
        )
    }

    OpenDialog(roleList) {
        this.reset(roleList)
        this.setState({
            dialogOpen: true,
            valid: false
        })
    }

    closeDialog() {
        this.setState({ dialogOpen: false })
    }

    confirm() {
        if (this.props.confirmCallback) {
            this.props.confirmCallback()
        }
        this.closeDialog()
    }

    stepperBack = () => {
        this.setState({
            stepper: {
                ...this.state.stepper,
                activeStep: this.state.stepper.activeStep - 1,
            },
        })
    }

    stepperNext = () => {
        let authorizationsCheckedKeys = [],
            authorizationsTreeData = [],
            pfSubPfTreeData = []

        if (this.state.stepper.activeStep === 0) {
            
            if (this.state.roleType === AUTH.ROLE_TYPE.ADMIN_ROLE) {
                // 新增最高權限
                const rootRoleInfo = this.state.adminRole
                authorizationsTreeData = utils.generateAuthTreeData(rootRoleInfo, 2)
                pfSubPfTreeData = utils.generatePfTreeData(rootRoleInfo)
            } else if (this.state.roleType === AUTH.ROLE_TYPE.ROOT_ROLE) {
                // 新增總代理
                authorizationsCheckedKeys = AUTH.RecommendationAuthMap[AUTH.RECOMMENDATION_AUTH_ROOT_ROLE]
                authorizationsTreeData = utils.generateAuthTreeData(null, 3)
                pfSubPfTreeData = utils.generatePfTreeData()
            } else if (this.state.roleType === AUTH.ROLE_TYPE.NORMAL_ROLE) {
                // 新增子代理
                const rootRoleInfo = this.state.rootRoleList.find((role) => {
                    return role['id'] === this.state.rootRoleID
                })
                const rootRoleId = rootRoleInfo?.root_role_id || rootRoleInfo?.id
                authorizationsTreeData = utils.generateAuthTreeData(rootRoleInfo, rootRoleId)
                pfSubPfTreeData = utils.generatePfTreeData(rootRoleInfo)
            }
        }

        this.setState({
            stepper: {
                ...this.state.stepper,
                activeStep: this.state.stepper.activeStep + 1,
            },
            name: '',
            authorizationsTreeData: authorizationsTreeData,
            pfSubPfTreeData: pfSubPfTreeData,
            authorizationsCheckedKeys: authorizationsCheckedKeys,
            pfSubPfCheckedKeys: [],
            canAccessAllPf: false,
        })
    }

    handleValidation() {
        let valid = false
        valid = this.state.name && String(this.state.name).length <= 20
        return valid
    }


    render() {
        const hasAddAdminAuth = this.props.auth.isSuperUser || this.props.auth.userInfo.authorization_list.includes('role.administrator')
        return (
            <Dialog maxWidth="md" fullWidth open={this.state.dialogOpen} onClose={() => this.setState({ dialogOpen: false })}>
                <DialogTitle>{this.t('Title')}</DialogTitle>
                <DialogContent>
                    <Grid container spacing={2}>
                        {this.props.auth.isAdmin && (
                            <Grid item xs={12}>
                                <Stepper activeStep={this.state.stepper.activeStep}>
                                    {this.state.stepper.steps.map((label, _index) => {
                                        return (
                                            <Step key={label}>
                                                <StepLabel>{this.t(label)}</StepLabel>
                                            </Step>
                                        )
                                    })}
                                </Stepper>
                            </Grid>
                        )}
                        {this.state.stepper.activeStep === 0 && (
                            <Grid item xs={4} style={{ margin: '0 5%' }}>
                                <RadioGroup
                                    value={this.state.roleType}
                                    onChange={(event) => {
                                        this.setState({ roleType: event.target.value })
                                    }}>
                                    {hasAddAdminAuth && <FormControlLabel value={AUTH.ROLE_TYPE.ADMIN_ROLE} control={<Radio />} label={this.t('normalmanager')} />}
                                    <FormControlLabel value={AUTH.ROLE_TYPE.ROOT_ROLE} control={<Radio />} label={this.t('rootRole')} />
                                    <FormControlLabel value={AUTH.ROLE_TYPE.NORMAL_ROLE} control={<Radio />} label={this.t('normalRole')} />
                                    {this.state.roleType === AUTH.ROLE_TYPE.NORMAL_ROLE && (
                                        <FormControl margin="dense" style={{ width: 240 }}>
                                            <InputLabel htmlFor="age-simple">{this.t('belongRootRole')}</InputLabel>
                                            <Select
                                                value={this.state.rootRoleID}
                                                onChange={(event) =>
                                                    this.setState({
                                                        rootRoleID: event.target.value,
                                                    })
                                                }>
                                                <MenuItem value={ROLE_ID_UNSET}>{this.t('pleaseSelect')}</MenuItem>
                                                {this.state.rootRoleList.map((rootRole) => (
                                                    <MenuItem value={rootRole['id']} key={rootRole['id']}>
                                                        {rootRole['name']}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    )}
                                </RadioGroup>
                            </Grid>
                        )}
                        {this.state.stepper.activeStep === 1 && (
                            <React.Fragment>
                                <Grid item xs={12} style={{ margin: '0 5%' }}>
                                    <TextField
                                        autoFocus
                                        label={this.t('name')}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        value={this.state.name}
                                        onChange={(event) =>
                                            this.setState({
                                                name: event.target.value,
                                            })
                                        }
                                        margin="dense"
                                        fullWidth
                                        required={true}
                                        error={this.state.valid && !this.handleValidation()}
                                        helperText={this.state.valid && !this.handleValidation() ? this.t('nameValidError'): ''}
                                    />
                                </Grid>

                                <Grid item xs={5} style={{ marginLeft: '5%' }}>
                                    <FormHelperText>
                                        <React.Fragment>
                                            {this.t('authorizations')}
                                            <Button
                                                style={{ marginLeft: '40%', marginRight: '5%' }}
                                                className={this.props.classes.linkButton}
                                                onClick={() => {
                                                    this.setState({
                                                        authorizationsCheckedKeys: utils.getTreeAllKeys(this.state.authorizationsTreeData),
                                                    })
                                                }}>
                                                {this.t('selectAll')}
                                            </Button>
                                            <Button
                                                className={this.props.classes.linkButton}
                                                onClick={() => {
                                                    this.setState({
                                                        authorizationsCheckedKeys: [],
                                                    })
                                                }}>
                                                {this.t('unselectAll')}
                                            </Button>
                                        </React.Fragment>
                                    </FormHelperText>
                                    <Tree
                                        treeData={this.state.authorizationsTreeData}
                                        checkedKeys={this.state.authorizationsCheckedKeys}
                                        expandedKeys={this.state.authorizationsExpandedKeys}
                                        onCheck={(checkedKeys) => {
                                            this.setState({
                                                authorizationsCheckedKeys: checkedKeys,
                                            })
                                        }}
                                        onExpand={(expandedKeys) => {
                                            this.setState({
                                                authorizationsExpandedKeys: expandedKeys,
                                            })
                                        }}
                                        checkable={true}
                                        selectable={false}
                                        style={{
                                            maxHeight: '40vh',
                                            overflowY: 'auto',
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={5} style={{ margin: '0 5%' }}>
                                    {this.state.roleType === AUTH.ROLE_TYPE.ADMIN_ROLE && (
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={this.state.canAccessAllPf}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            canAccessAllPf: event.target.checked,
                                                        })
                                                    }}
                                                    color="primary"
                                                />
                                            }
                                            label={this.t('canAccessAllPf')}
                                        />
                                    )}
                                    {!this.state.canAccessAllPf && (
                                        <React.Fragment>
                                            <FormHelperText>
                                                <React.Fragment>
                                                    {this.t('pfSubPf')}
                                                    <Button
                                                        style={{ marginLeft: '40%', marginRight: '5%' }}
                                                        className={this.props.classes.linkButton}
                                                        onClick={() => {
                                                            this.setState({
                                                                pfSubPfCheckedKeys: utils.getTreeAllKeys(this.state.pfSubPfTreeData),
                                                            })
                                                        }}>
                                                        {this.t('selectAll')}
                                                    </Button>
                                                    <Button
                                                        className={this.props.classes.linkButton}
                                                        onClick={() => {
                                                            this.setState({
                                                                pfSubPfCheckedKeys: [],
                                                            })
                                                        }}>
                                                        {this.t('unselectAll')}
                                                    </Button>
                                                </React.Fragment>
                                            </FormHelperText>
                                            <Tree
                                                treeData={this.state.pfSubPfTreeData}
                                                checkedKeys={this.state.pfSubPfCheckedKeys}
                                                expandedKeys={this.state.pfSubPfExpandedKeys}
                                                onCheck={(checkedKeys) => {
                                                    this.setState({
                                                        pfSubPfCheckedKeys: checkedKeys,
                                                    })
                                                }}
                                                onExpand={(expandedKeys) => {
                                                    this.setState({
                                                        pfSubPfExpandedKeys: expandedKeys,
                                                    })
                                                }}
                                                checkable={true}
                                                selectable={false}
                                                style={{
                                                    maxHeight: '40vh',
                                                    overflowY: 'auto',
                                                }}
                                            />
                                        </React.Fragment>
                                    )}
                                </Grid>
                            </React.Fragment>
                        )}
                    </Grid>
                </DialogContent>
                <Divider />
                <DialogActions>
                    {this.props.auth.isAdmin && (
                        <Button disabled={this.state.stepper.activeStep === 0} onClick={this.stepperBack}>
                            {this.t('back')}
                        </Button>
                    )}
                    {this.state.stepper.activeStep < this.state.stepper.steps.length - 1 ? (
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={this.stepperNext}
                            disabled={
                                this.state.stepper.activeStep === 0 &&
                                this.state.roleType === AUTH.ROLE_TYPE.NORMAL_ROLE &&
                                this.state.rootRoleID === ROLE_ID_UNSET
                            }>
                            {this.t('next')}
                        </Button>
                    ) : (
                        <Button
                            variant="contained"
                            onClick={() => {
                                const is_root_role = this.state.roleType === AUTH.ROLE_TYPE.ROOT_ROLE
                                const pf_sub_pf_id_list = this.state.pfSubPfCheckedKeys.filter((ele) => ele.search(/_/) > -1)
                                const authorization_list = this.state.authorizationsCheckedKeys.filter((ele) => ele.search(/\./) > -1)
                                let error = false
                                this.setState({
                                    valid: true
                                })

                                error = !this.handleValidation()
                                /** 最高權限未使用"允许存取所有平台",且無勾選任何平台 */
                                if ((this.state.canAccessAllPf === false && this.state.roleType === AUTH.ROLE_TYPE.ADMIN_ROLE) && !pf_sub_pf_id_list.length) {
                                    utils.addToast(this.t('pfValidError'), 'error')
                                    error = true
                                }
                                /** 非最高權限且無勾選任何平台 */
                                if (this.state.roleType !== AUTH.ROLE_TYPE.ADMIN_ROLE && !pf_sub_pf_id_list.length) {
                                    utils.addToast(this.t('pfValidError'), 'error')
                                    error = true
                                }
                                if (!authorization_list.length) {
                                    utils.addToast(this.t('authValidError'), 'error')
                                    error = true
                                }
                                if (error) { return }
                                const root_role_id = this.state.rootRoleID !== ROLE_ID_UNSET ? this.state.rootRoleID : this.state.roleType === AUTH.ROLE_TYPE.ADMIN_ROLE ? 2 : null
                                utils.apiRequest(
                                    'post',
                                    API.ROLE,
                                    {
                                        name: this.state.name,
                                        is_root_role: is_root_role,
                                        root_role_id,
                                        can_access_all_pf: this.state.canAccessAllPf,
                                        pf_sub_pf_id_list: pf_sub_pf_id_list,
                                        authorization_list: authorization_list,
                                    },
                                    (_data) => {
                                        this.confirm()
                                    }
                                )
                            }}
                            color="primary">
                            {this.t('confirm')}
                        </Button>
                    )}
                    <Button variant="contained" onClick={() => this.closeDialog()} color="secondary">
                        {this.t('cancel')}
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

const styles = (_theme) => {
    return {
        linkButton: {
            background: 'none!important',
            border: 'none',
            padding: '0!important',
            color: '#1890ff',
            textDecoration: 'none',
            cursor: 'pointer',
            userSelect: 'text',
            fontSize: '0.75rem',
        },
    }
}

AddRoleDialog.propTypes = {
    classes: PropTypes.object.isRequired,
    onRef: PropTypes.func,
    auth: PropTypes.object,
    confirmCallback: PropTypes.func,
    dataService: PropTypes.object,
}

export default hoc(styles)(AddRoleDialog)
